import { Middleware, PayloadAction } from '@reduxjs/toolkit';
import { getUser } from 'actions/auth';

import { AppDispatch } from 'store';
import { RootStateType } from 'store/rootReducer';
import { guestSessionFinished, setGuestData } from 'store/reducers/guestSlice';
import { setUserInfo } from 'store/reducers/persistAuthSlice';
import { authSessionFinished } from 'store/reducers/userSlice';

interface RehydrateAction {
  type: 'persist/REHYDRATE';
  payload: RootStateType;
}

const authMiddleware: Middleware = (store) => (next) => async (action) => {
  const reduxAction = action as PayloadAction<RehydrateAction['payload']>;
  const dispatch = store.dispatch as AppDispatch;
  const isRehydrateStage = reduxAction?.type === 'persist/REHYDRATE';

  if (isRehydrateStage && reduxAction.payload) {
    const userInfo = reduxAction.payload?.persistAuth?.userInfo;
    const guestInfo = reduxAction.payload?.persistGuestAuth?.guestInfo;

    if (userInfo) {
      dispatch(setUserInfo(userInfo));
      dispatch(guestSessionFinished());
      dispatch(getUser());
    } else if (guestInfo) {
      dispatch(authSessionFinished());
      dispatch(setGuestData(guestInfo));
    }
  }

  return next(action);
};

export default authMiddleware;
